import { Button } from '@orbita-ui/core';
import { RefundData } from 'core/cuenta/models/RefundData';
import { Col, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { DISTRIBUTION_ERRORS } from 'shared/constants/GenericMessages';
import { FormWithValidation } from 'shared/form';
import { FormattedAmountInput } from 'shared/form/components/FormattedAmountInput';
import { ButtonPlaceholder, TextPlaceholder } from 'shared/placeholders';

export interface IRefundForm {
  refund: number;
}

export const RefundsForm = ({
  refundData,
  onSubmit,
  partialRefund,
}: {
  refundData: RefundData;
  onSubmit: (data: IRefundForm) => void;
  partialRefund: boolean;
}) => {
  const saldoDisponible = refundData ? Number(refundData.saldoDisponible) : 0;

  return (
    <Card>
      <Card.Body $padding>
        {refundData ? (
          <FormWithValidation
            onSubmit={onSubmit}
            formProps={{
              defaultValues: {
                refund: partialRefund ? undefined : saldoDisponible,
              },
            }}
          >
            <Row className="align-items-center">
              <Col>
                <FormattedAmountInput
                  data-testid="refund-field"
                  name="refund"
                  disabled={!partialRefund}
                  label="Monto a transferir $"
                  placeholder="0,00"
                  validationRules={{
                    required: {
                      value: true,
                      message: DISTRIBUTION_ERRORS.amountBelowMin,
                    },
                    max: {
                      value: saldoDisponible,
                      message: DISTRIBUTION_ERRORS.amountExceedsMax,
                    },
                    min: {
                      value: 0.01,
                      message: DISTRIBUTION_ERRORS.amountBelowMin,
                    },
                  }}
                />
              </Col>

              <Col md="auto" >
                <Button type="submit" data-testid="submit-button">
                  Confirmar
                </Button>
              </Col>
            </Row>
          </FormWithValidation>
        ) : (
          <Row className="align-items-center">
            <Col>
              <TextPlaceholder height={80} />
            </Col>
            <Col md="auto">
              <ButtonPlaceholder>Confirmar</ButtonPlaceholder>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};
